import { Mui } from '@osu/react-ui';
import { STATUS } from '../../util/constants';
import { useMemo } from 'react';

const HoldSwitch = ({ applicationStatus, committee, admitTerm, studentData, holdForExport, toggleHoldForExport }) => {

  const getLabel = useMemo(() => {
    switch (applicationStatus) {
      case STATUS.ADMINREVIEW:
      case STATUS.PENDINGAPPROVAL:
        return 'Hold for Information';
      default:
        return '';
    }
  }, [applicationStatus]);

  const getDefaultChecked = useMemo(() => {
    return holdForExport;
  }, [holdForExport]);

  const handleOnChange = (val) => {
    switch (applicationStatus) {
      case STATUS.ADMINREVIEW:
      case STATUS.PENDINGAPPROVAL:
        toggleHoldForExport(studentData?.data?.demographics?.applicantEmployeeId, committee, admitTerm, val.target.checked)
        break;
      default:
        return null;
    }
  }

  return (
    <Mui.FormGroup style={{paddingBottom: '.2rem'}}>
      <Mui.FormControlLabel
        control={
          <Mui.Switch color="primary" checked={getDefaultChecked}
            onChange={(val) => {
              handleOnChange(val)
            }} inputProps={{ 'aria-label': getLabel }} />}
        label={getLabel}
      />
    </Mui.FormGroup>
  )

}
export default HoldSwitch;


